<template>
<div class="container">
  <span class="userinfo">{{userInfo.clientName}}</span>
  <div class="count">{{count}}</div>
  <div class="bottom-nav-scan-btn" >
    <img class="bottom-nav-icon-scan" @click="scanCode" src="../../assets/images/activity/1220scanqrcode-btn.png">
  </div>
</div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import activityApi from '@/api/activity'
import { Dialog } from 'vant'
import { userUtils } from '@/utils/auth'
export default {
  data () {
    return {
      userInfo: {},
      count: ''
    }
  },
  created () {
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })

    this.userInfo = userUtils.getClientInfo()
    console.log(this.userInfo)
    this.getCount()
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
  },
  methods: {
    getCount () {
      activityApi.qrCodeQueryCount().then(res => {
        if (res.data.resultCode === '0') {
          this.count = res.data.resultData.count
        }
      })
    },

    // 扫码
    scanCode () {
      // 测试
      // let code = {
      //   scanCode: '1WZVRCG6BYB77P39DP'
      // }
      // this.lotteryScan(code)
      // if (!this.clientInfo) {
      //   window.location.href = commonUtils.getExtraSite() + '/#/login' + '?redirectUrl'
      // }
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData = {
            scanCode: res.resultStr
          }
          this.getLocation(scanData)
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },

    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.qrCodeScan(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },

    // 扫码结果
    qrCodeScan (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.qrCodeScan(value).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          Dialog.alert({
            message: '扫码成功'
          })
          this.getCount()
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>

<style scoped>
.container{
  width: 100vw;
  height: 100vh;
  background-image: url('../../assets/images/activity/1220scanqrcode-bg.png');
  background-size: 100vw 100vh;
  text-align: center;
}
.userinfo{
  position: relative;
  top: 43vh;
  font-size: 15px;
  width: auto;
  height: 25px;
  padding-bottom: 4px;
  border-bottom: solid 1px black;
}
.count{
  position: relative;
  top: 55vh;
  font-size: 30px;
  color: rgb(207, 0, 0);
  font-weight: 500;
}
.bottom-nav-icon-scan{
  width: 150px;
  position: relative;
  top: 67vh;
}
</style>
